// reducers/index.js
import { combineReducers } from 'redux';
import mediaQueryReducer from './MediaQueryReducer';

const globalReducers = combineReducers({
    mediaQueryReducer
});

export default globalReducers;